var _symbol, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vector_x5F_sprite_x5F_all",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "350px",
    height: "130px",
    viewBox: "0 0 350 130",
    enableBackground: "new 0 0 350 130",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "_x34_04_1_",
    viewBox: "-175 -65 350 130"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M-102.004-19L-102,65h-13l-60-84v-15h57v-31h16v31h17v15H-102.004z M-118-19h-41l41,58V-19z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E31837",
    d: "M2-65c-35.841,0-65,29.159-65,65s29.159,65,65,65S67,35.841,67,0S37.841-65,2-65z M2,61 c-33.636,0-61-27.364-61-61s27.364-61,61-61S63-33.636,63,0S35.636,61,2,61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E31837",
    d: "M-19,15c0-2.761-2.239-5-5-5s-5,2.239-5,5s2.239,5,5,5S-19,17.761-19,15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E31837",
    d: "M32,15c0-2.761-2.239-5-5-5s-5,2.239-5,5s2.239,5,5,5S32,17.761,32,15z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E31837",
    points: "28,-28 -25,-28 -25,-25 28,-25  "
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#595959",
    d: "M157.996-19L158,65h-13L85-19v-15h57v-31h16v31h17v15H157.996z M142-19h-41l41,58V-19z"
  }), /*#__PURE__*/React.createElement("polygon", {
    display: "none",
    fill: "none",
    points: "-175,65 175,65 175,-65 -175,-65  "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x34_04"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_x34_04_1_",
    width: 350,
    height: 130,
    x: -175,
    y: -65,
    transform: "matrix(1 0 0 -1 175 65)",
    overflow: "visible"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError404);
export default __webpack_public_path__ + "static/media/error-404.b047637d16ff1a4b6346129303670f74.svg";
export { ForwardRef as ReactComponent };